<div class="page-head">
  <div>
    <p class="eyebrow">การเงิน</p>
    <h1>ตรวจสอบการชำระเงิน</h1>
    <p>ตรวจสอบหลักฐานและยืนยันยอดรับจากลูกค้า</p>
  </div>
  <!--   <button
    type="button"
    class="tw-button inline-flex items-center justify-center gap-2 rounded-xl bg-[var(--theme-color)] px-4 py-2.5 text-sm font-semibold text-white shadow-sm transition hover:bg-[var(--theme-hover)] focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-sky-600 active:scale-[0.98]"
  >
    <lucide-icon name="Plus" [size]="17" /> เพิ่มการชำระ
  </button> -->
</div>

<section class="rounded-xl border border-slate-200 bg-white shadow-sm">
  <p-table
    #paymentsTable
    [value]="payments()"
    dataKey="id"
    [paginator]="true"
    [rows]="10"
    [rowsPerPageOptions]="[10, 25, 50]"
    [globalFilterFields]="[
      'bookingCode',
      'tripName',
      'customerName',
      'payerName',
      'paymentType',
      'status',
    ]"
    [rowHover]="true"
    [showCurrentPageReport]="true"
    currentPageReportTemplate="แสดง {first} ถึง {last} จาก {totalRecords} รายการ"
    styleClass="payments-table"
    [tableStyle]="{ 'min-width': '1020px' }"
  >
    <ng-template #caption>
      <div class="flex flex-col gap-3 lg:flex-row lg:items-center lg:justify-between">
        <label class="relative block w-full lg:max-w-md">
          <lucide-icon
            name="Search"
            [size]="17"
            class="pointer-events-none absolute top-1/2 left-2 z-10 -translate-y-1/2 text-slate-400"
          />
          <input
            pInputText
            #search
            class="h-11 w-full pr-3 text-sm placeholder:text-slate-400"
            style="padding-left: 2.75rem; border-radius: 0.5rem"
            placeholder="ค้นหา Booking ทัวร์ ลูกค้า หรือผู้ชำระ"
            (input)="paymentsTable.filterGlobal(search.value, 'contains')"
          />
        </label>

        <div class="flex items-center justify-end gap-3">
          <p class="m-0 text-xs text-slate-500">
            รอตรวจสอบทั้งหมด
            <span class="font-semibold text-slate-700">{{ payments().length }}</span>
            รายการ
          </p>
          <app-refresh-button
            label="รีเฟรชรายการตรวจสอบการชำระเงิน"
            [loading]="isLoadingPayments()"
            (refresh)="loadPayments()"
          />
        </div>

        <!-- <p-select
          class="w-full lg:w-52"
          [options]="statusOptions"
          [(ngModel)]="selectedStatus"
          optionLabel="label"
          optionValue="value"
          placeholder="ทุกสถานะ"
          [showClear]="true"
          (onChange)="paymentsTable.filter($event.value, 'status', 'equals')"
        />

        <p-datepicker
          class="w-full lg:w-52"
          [(ngModel)]="selectedDate"
          dateFormat="dd/mm/yy"
          placeholder="วันที่ชำระ"
          [showIcon]="true"
          [showClear]="true"
          [readonlyInput]="true"
          (onSelect)="paymentsTable.filter(toDateFilter($event), 'paidAt', 'equals')"
          (onClear)="paymentsTable.filter(null, 'paidAt', 'equals')"
          appendTo="body"
        /> -->
      </div>
    </ng-template>

    <ng-template #header>
      <tr>
        <th class="w-14 text-center text-xs whitespace-nowrap">ลำดับ</th>
        <th pSortableColumn="bookingCode" class="min-w-64 text-xs whitespace-nowrap">
          Booking และทัวร์ <p-sortIcon field="bookingCode" />
        </th>
        <th pSortableColumn="customerName" class="min-w-56 text-xs whitespace-nowrap">
          ลูกค้าและผู้ชำระ <p-sortIcon field="customerName" />
        </th>
        <th pSortableColumn="paidAt" class="min-w-48 text-xs whitespace-nowrap">
          รายละเอียดการชำระ <p-sortIcon field="paidAt" />
        </th>
        <th pSortableColumn="amount" class="min-w-52 text-right text-xs whitespace-nowrap">
          ยอดชำระ <p-sortIcon field="amount" />
        </th>
        <th pSortableColumn="status" class="w-40 text-xs whitespace-nowrap">
          สถานะ <p-sortIcon field="status" />
        </th>
        <th class="w-28 text-right text-xs whitespace-nowrap">ดำเนินการ</th>
      </tr>
    </ng-template>

    <ng-template #body let-row let-rowIndex="rowIndex">
      <tr class="transition even:bg-slate-50/40 hover:bg-sky-50/60">
        <td class="py-3.5 text-center text-[13px] text-slate-400 tabular-nums align-top">
          {{ rowIndex + 1 }}
        </td>
        <td class="py-3.5 text-[13px] align-top">
          <p class="m-0 text-sm font-semibold whitespace-nowrap text-sky-700">
            {{ row.bookingCode }}
          </p>
          <p class="mt-1 mb-0 max-w-72 text-xs leading-5 text-slate-500">
            {{ row.tripName || 'ไม่ระบุโปรแกรมทัวร์' }}
          </p>
        </td>
        <td class="py-3.5 text-[13px] align-top">
          <p class="m-0 text-sm font-medium leading-5 text-slate-800">
            {{ row.customerName }}
          </p>
          <p class="mt-1 mb-0 text-xs text-slate-500">
            ผู้ชำระ: {{ row.payerName || '—' }}
          </p>
        </td>
        <td class="py-3.5 text-[13px] align-top">
          <p class="m-0 text-sm font-medium text-slate-700">
            {{ paymentTypeLabel(row.paymentType) }}
          </p>
          <p class="mt-1 mb-0 text-xs whitespace-nowrap text-slate-500">
            {{ row.paidAt | date: 'dd MMM yyyy' }}
            @if (row.paidTime) {
              · {{ row.paidTime }} น.
            }
          </p>
        </td>
        <td class="py-3.5 text-right tabular-nums align-top">
          <p class="m-0 text-sm font-semibold whitespace-nowrap text-slate-800">
            {{ row.amount | number: '1.2-2' }} บาท
          </p>
          @if (row.creditCardFeeAmount > 0) {
            <p class="mt-1 mb-0 text-xs leading-5 text-slate-500">
              ค่าธรรมเนียมบัตร
              @if (row.creditCardFeeResponsibility === 'CUSTOMER') {
                (ลูกค้ารับภาระ)
              } @else {
                (บริษัทรับภาระ)
              }
              <span class="font-semibold text-amber-700">
                {{ row.creditCardFeeAmount | number: '1.2-2' }} บาท
              </span>
            </p>
          }
          @if (row.withholdingTaxAmount > 0) {
            <p class="mt-1 mb-0 text-xs leading-5 text-slate-500">
              หัก ณ ที่จ่าย
              <span class="font-semibold text-slate-700">-{{ row.withholdingTaxAmount | number: '1.2-2' }} บาท</span>
            </p>
          }
        </td>
        <td class="py-3.5 align-top">
          <app-status-badge [status]="row.status" />
        </td>
        <td class="py-3.5 align-top">
          <div class="flex justify-end gap-1.5">
            @if (row.slipUrl) {
              <button
                class="tw-button inline-flex size-8 items-center justify-center rounded-lg border border-slate-200 bg-white p-0 text-slate-600 hover:bg-slate-50"
                type="button"
                title="เปิดหลักฐานการชำระเงิน"
                (click)="openAttachment(row.slipUrl)"
              >
                <lucide-icon name="FileText" [size]="15" />
              </button>
            }
            <button
              class="tw-button inline-flex size-8 items-center justify-center rounded-lg border border-slate-200 bg-white p-0 text-slate-600 hover:bg-slate-50"
              type="button"
              title="ดูรายละเอียด"
              (click)="openPaymentDetail(row)"
            >
              <lucide-icon name="Eye" [size]="15" />
            </button>
            <!--  @if (row.status === 'WAITING_VERIFY') {
              <button
                class="tw-button inline-flex items-center gap-1.5 rounded-lg bg-emerald-600 px-3 py-2 text-xs font-semibold text-white hover:bg-emerald-700"
                type="button"
                (click)="approvePayment(row)"
              >
                <lucide-icon name="Check" [size]="15" /> ยืนยันยอด
              </button>
            } -->
          </div>
        </td>
      </tr>
    </ng-template>

    <ng-template #emptymessage>
      <tr>
        <td colspan="7">
          <div class="empty">
            <h3>ไม่พบรายการชำระ</h3>
            <p>ลองเปลี่ยนคำค้นหาหรือตัวกรอง</p>
          </div>
        </td>
      </tr>
    </ng-template>
  </p-table>
</section>

@if (selectedPayment(); as payment) {
  <div
    class="fixed inset-0 z-[200] grid place-items-center overflow-y-auto bg-slate-950/45 p-4 backdrop-blur-[2px]"
    (click)="closePaymentDetail()"
  >
    <section
      class="my-auto w-full max-w-4xl overflow-hidden rounded-2xl border border-slate-200 bg-white shadow-2xl"
      role="dialog"
      aria-modal="true"
      aria-labelledby="payment-detail-title"
      (click)="$event.stopPropagation()"
    >
      <div class="flex items-start justify-between border-b border-slate-200 px-5 py-5 sm:px-6">
        <div>
          <p class="mb-1 text-xs font-semibold tracking-wider text-sky-600 uppercase">
            {{ payment.bookingCode }}
          </p>
          <h2 id="payment-detail-title" class="m-0 text-xl font-bold text-slate-800">
            รายละเอียดการชำระเงิน
          </h2>
          <div class="mt-2"><app-status-badge [status]="payment.status" /></div>
        </div>
        <button
          type="button"
          class="tw-button inline-flex size-10 items-center justify-center rounded-xl border border-slate-200 bg-white text-slate-600 hover:bg-slate-50"
          aria-label="ปิดหน้าต่าง"
          (click)="closePaymentDetail()"
        >
          <lucide-icon name="X" [size]="19" aria-hidden="true" />
        </button>
      </div>

      <div class="max-h-[68vh] overflow-y-auto p-5 sm:p-6">
        <section>
          <h3 class="m-0 text-base font-bold text-slate-800">ข้อมูล Booking</h3>
          <dl
            class="mt-4 grid gap-4 rounded-xl border border-slate-200 bg-slate-50 p-4 sm:grid-cols-2 lg:grid-cols-3"
          >
            <div>
              <dt class="text-xs font-semibold text-slate-500">เลขที่ Booking</dt>
              <dd class="mt-1 mb-0 font-semibold text-slate-800">{{ payment.bookingCode }}</dd>
            </div>
            <div>
              <dt class="text-xs font-semibold text-slate-500">โปรแกรมทัวร์</dt>
              <dd class="mt-1 mb-0 font-semibold text-slate-800">{{ payment.tripName }}</dd>
            </div>
            <div>
              <dt class="text-xs font-semibold text-slate-500">วันเดินทาง</dt>
              <dd class="mt-1 mb-0 font-semibold text-slate-800">
                {{ payment.travelDate | date: 'dd MMM yyyy' }}
              </dd>
            </div>
            <div>
              <dt class="text-xs font-semibold text-slate-500">จำนวนผู้เดินทาง</dt>
              <dd class="mt-1 mb-0 font-semibold text-slate-800">
                {{ payment.travelerCount | number }} คน
              </dd>
            </div>
            <div>
              <dt class="text-xs font-semibold text-slate-500">ยอด Booking</dt>
              <dd class="mt-1 mb-0 font-semibold text-slate-800">
                {{ payment.bookingTotal | number: '1.2-2' }} บาท
              </dd>
            </div>
          </dl>
        </section>

        <section class="mt-6">
          <h3 class="m-0 text-base font-bold text-slate-800">ข้อมูลลูกค้า</h3>
          <dl
            class="mt-4 grid gap-4 rounded-xl border border-slate-200 bg-slate-50 p-4 sm:grid-cols-2 lg:grid-cols-3"
          >
            <div>
              <dt class="text-xs font-semibold text-slate-500">รหัสลูกค้า</dt>
              <dd class="mt-1 mb-0 font-semibold text-slate-800">{{ payment.customer.customerCode }}</dd>
            </div>
            <div>
              <dt class="text-xs font-semibold text-slate-500">ประเภทลูกค้า</dt>
              <dd class="mt-1 mb-0 font-semibold text-slate-800">
                {{ payment.customer.customerType === 'CORPORATE' ? 'บริษัท / นิติบุคคล' : 'บุคคลทั่วไป' }}
              </dd>
            </div>
            <div>
              <dt class="text-xs font-semibold text-slate-500">ชื่อลูกค้า / บริษัท</dt>
              <dd class="mt-1 mb-0 font-semibold text-slate-800">{{ payment.customer.name }}</dd>
            </div>
            <div>
              <dt class="text-xs font-semibold text-slate-500">เลขผู้เสียภาษี / บัตรประชาชน</dt>
              <dd class="mt-1 mb-0 font-semibold text-slate-800">{{ payment.customer.taxId || '—' }}</dd>
            </div>
            <div>
              <dt class="text-xs font-semibold text-slate-500">เบอร์โทรศัพท์</dt>
              <dd class="mt-1 mb-0 font-semibold text-slate-800">{{ payment.customer.phone || '—' }}</dd>
            </div>
            <div>
              <dt class="text-xs font-semibold text-slate-500">อีเมล</dt>
              <dd class="mt-1 mb-0 break-all font-semibold text-slate-800">{{ payment.customer.email || '—' }}</dd>
            </div>
            <div>
              <dt class="text-xs font-semibold text-slate-500">LINE ID</dt>
              <dd class="mt-1 mb-0 font-semibold text-slate-800">{{ payment.customer.lineId || '—' }}</dd>
            </div>
            <div class="sm:col-span-2">
              <dt class="text-xs font-semibold text-slate-500">ที่อยู่</dt>
              <dd class="mt-1 mb-0 whitespace-pre-line text-slate-800">{{ payment.customer.address || '—' }}</dd>
            </div>
            <div class="sm:col-span-2 lg:col-span-3">
              <dt class="text-xs font-semibold text-slate-500">เอกสารแนบของลูกค้า</dt>
              <dd class="mt-1 mb-0 font-semibold">
                @if (payment.customer.fileUrl) {
                  <button
                    type="button"
                    class="inline-flex items-center gap-1.5 text-sky-700 hover:text-sky-900"
                    title="ดูเอกสารแนบในแท็บใหม่"
                    (click)="openAttachment(payment.customer.fileUrl)"
                  >
                    ดูเอกสารแนบ
                    <lucide-icon name="ExternalLink" [size]="15" />
                  </button>
                } @else {
                  <span class="text-slate-500">—</span>
                }
              </dd>
            </div>
          </dl>
        </section>

        <section class="mt-6">
          <h3 class="m-0 text-base font-bold text-slate-800">สรุปราคา</h3>
          <dl
            class="mt-4 grid gap-4 rounded-xl border border-slate-200 bg-slate-50 p-4 sm:grid-cols-2 lg:grid-cols-3"
          >
            <div>
              <dt class="text-xs font-semibold text-slate-500">ราคาทัวร์ทั้งหมด</dt>
              <dd class="mt-1 mb-0 font-semibold text-slate-800">
                {{ totalTourPrice(payment) | number: '1.2-2' }} บาท
              </dd>
            </div>
            <div>
              <dt class="text-xs font-semibold text-slate-500">ส่วนลดทั้งหมด</dt>
              <dd class="mt-1 mb-0 font-semibold text-rose-700">
                {{ totalDiscount(payment) | number: '1.2-2' }} บาท
              </dd>
            </div>
            <div>
              <dt class="text-xs font-semibold text-slate-500">ค่าใช้จ่ายโดยประมาณ</dt>
              <dd class="mt-1 mb-0 font-semibold text-amber-700">
                {{ payment.estimatedExpense | number: '1.2-2' }} บาท
              </dd>
            </div>
            <div>
              <dt class="text-xs font-semibold text-slate-500">ค่าธรรมเนียม (ลูกค้า)</dt>
              <dd class="mt-1 mb-0 font-semibold text-slate-800">
                {{ (payment.creditCardFeeResponsibility === 'CUSTOMER' ? payment.creditCardFeeAmount : 0) | number: '1.2-2' }} บาท
              </dd>
            </div>
            <div>
              <dt class="text-xs font-semibold text-slate-500">ค่าธรรมเนียม (บริษัท)</dt>
              <dd class="mt-1 mb-0 font-semibold text-red-600">
                {{ (payment.creditCardFeeResponsibility === 'COMPANY' ? payment.creditCardFeeAmount : 0) | number: '1.2-2' }} บาท
              </dd>
            </div>
            <div>
              <dt class="text-xs font-semibold text-slate-500">
                {{ estimatedProfit(payment) < 0 ? 'ขาดทุนโดยประมาณ' : 'กำไรโดยประมาณ' }}
              </dt>
              <dd
                class="mt-1 mb-0 text-lg font-bold"
                [class.text-emerald-700]="estimatedProfit(payment) >= 0"
                [class.text-red-600]="estimatedProfit(payment) < 0"
              >
                {{ estimatedProfit(payment) | number: '1.2-2' }} บาท
              </dd>
            </div>
          </dl>
          <p class="mt-2 mb-0 text-xs text-slate-500">
            กำไรโดยประมาณคำนวณจากยอด การจอด − ค่าใช้จ่ายโดยประมาณ
          </p>
        </section>

        <section class="mt-6">
          <h3 class="m-0 text-base font-bold text-slate-800">ข้อมูลการชำระเงิน</h3>
          <dl
            class="mt-4 grid gap-4 rounded-xl border border-slate-200 bg-slate-50 p-4 sm:grid-cols-2 lg:grid-cols-3"
          >
            <div>
              <dt class="text-xs font-semibold text-slate-500">ชื่อผู้ชำระเงิน</dt>
              <dd class="mt-1 mb-0 font-semibold text-slate-800">{{ payment.payerName }}</dd>
            </div>
            <div>
              <dt class="text-xs font-semibold text-slate-500">ประเภทการชำระ</dt>
              <dd class="mt-1 mb-0 font-semibold text-slate-800">{{ payment.paymentType }}</dd>
            </div>
            <div>
              <dt class="text-xs font-semibold text-slate-500">จำนวนเงิน</dt>
              <dd class="mt-1 mb-0 font-semibold text-emerald-700">
                {{ payment.amount | number: '1.2-2' }} บาท
              </dd>
            </div>
            <div>
              <dt class="text-xs font-semibold text-slate-500">หัก ณ ที่จ่าย</dt>
              <dd class="mt-1 mb-0 font-semibold text-slate-700">
                -{{ payment.withholdingTaxAmount | number: '1.2-2' }} บาท
              </dd>
            </div>
            @if (payment.creditCardFeeResponsibility) {
              <div>
                <dt class="text-xs font-semibold text-slate-500">อัตราค่าธรรมเนียม</dt>
                <dd class="mt-1 mb-0 font-semibold text-slate-800">
                  {{ payment.creditCardFeePercent }}%
                </dd>
              </div>
              <div>
                <dt class="text-xs font-semibold text-slate-500">ค่าธรรมเนียม (ลูกค้า)</dt>
                <dd class="mt-1 mb-0 font-semibold text-slate-800">
                  {{ (payment.creditCardFeeResponsibility === 'CUSTOMER' ? payment.creditCardFeeAmount : 0) | number: '1.2-2' }} บาท
                </dd>
              </div>
              <div>
                <dt class="text-xs font-semibold text-slate-500">ค่าธรรมเนียม (บริษัท)</dt>
                <dd class="mt-1 mb-0 font-semibold text-red-600">
                  {{ (payment.creditCardFeeResponsibility === 'COMPANY' ? payment.creditCardFeeAmount : 0) | number: '1.2-2' }} บาท
                </dd>
              </div>
            }
            <div>
              <dt class="text-xs font-semibold text-slate-500">วันที่ชำระ</dt>
              <dd class="mt-1 mb-0 font-semibold text-slate-800">
                {{ payment.paidAt | date: 'dd MMM yyyy' }}
              </dd>
            </div>
            <div>
              <dt class="text-xs font-semibold text-slate-500">เวลา</dt>
              <dd class="mt-1 mb-0 font-semibold text-slate-800">{{ payment.paidTime }} น.</dd>
            </div>
            <div>
              <dt class="text-xs font-semibold text-slate-500">ไฟล์สลิป</dt>
              <dd class="mt-1 mb-0 break-all font-semibold text-sky-700">
                @if (payment.slipUrl) {
                  <button
                    type="button"
                    class="inline-flex items-center gap-1.5 text-sky-700 decoration-sky-300 hover:text-sky-900 "
                    title="ดูเอกสารแนบในแท็บใหม่"
                    (click)="openAttachment(payment.slipUrl)"
                  >
                    ดูเอกสารแนบ
                    <lucide-icon name="ExternalLink" [size]="15" />
                  </button>
                } @else {
                  <span class="text-slate-500">ไม่มีไฟล์แนบ</span>
                }
              </dd>
            </div>
          </dl>
        </section>

        @if (payment.status === 'WAITING_VERIFY') {
          <section class="mt-6">
            <h3 class="m-0 text-base font-bold text-slate-800">เอกสารประกอบ</h3>
            <div class="mt-4 grid gap-4 rounded-xl border border-slate-200 bg-slate-50 p-4 sm:grid-cols-2">
              <label class="grid content-start gap-1 text-sm font-semibold text-slate-700">
                <span>ลิงก์ใบเสร็จ <span class="text-red-500">*</span></span>
                <input
                  type="url"
                  pInputText
                  class="h-11 w-full font-normal"
                  [class.p-invalid]="!!receiptUrlError()"
                  [(ngModel)]="payment.receiptUrl"
                  (ngModelChange)="clearReceiptUrlError()"
                  placeholder="https://example.com/receipt"
                />
                <span class="min-h-4">
                  @if (receiptUrlError()) {
                    <small class="font-normal text-red-600">{{ receiptUrlError() }}</small>
                  }
                </span>
              </label>

              <label class="grid content-start gap-1 text-sm font-semibold text-slate-700">
                <span>ลิงก์ใบเสนอราคา <span class="text-red-500">*</span></span>
                <input
                  type="url"
                  pInputText
                  class="h-11 w-full font-normal"
                  [class.p-invalid]="!!quotationUrlError()"
                  [(ngModel)]="payment.quotationUrl"
                  (ngModelChange)="clearQuotationUrlError()"
                  placeholder="https://example.com/quotation"
                />
                <span class="min-h-4">
                  @if (quotationUrlError()) {
                    <small class="font-normal text-red-600">{{ quotationUrlError() }}</small>
                  }
                </span>
              </label>
            </div>
          </section>
        }

      </div>

      <div
        class="flex flex-col-reverse gap-3 border-t border-slate-200 bg-slate-50 px-5 py-4 sm:flex-row sm:justify-end sm:px-6"
      >
        <button
          type="button"
          class="tw-button h-11 rounded-xl border border-slate-300 bg-white px-5 text-[15px] font-semibold text-slate-700 hover:bg-slate-100"
          (click)="closePaymentDetail()"
        >
          ปิด
        </button>
        @if (payment.status === 'WAITING_VERIFY') {
          <button
            type="button"
            class="tw-button inline-flex h-11 items-center justify-center gap-2 rounded-xl border border-red-200 bg-white px-5 text-[15px] font-semibold text-red-600 hover:bg-red-50"
            (click)="rejectPayment(payment)"
          >
            <lucide-icon name="X" [size]="17" aria-hidden="true" /> ไม่อนุมัติ
          </button>
          <button
            type="button"
            class="tw-button inline-flex h-11 items-center justify-center gap-2 rounded-xl bg-emerald-600 px-5 text-[15px] font-semibold text-white hover:bg-emerald-700"
            (click)="approvePayment(payment)"
          >
            <lucide-icon name="Check" [size]="17" aria-hidden="true" /> อนุมัติ
          </button>
        }
      </div>
    </section>
  </div>
}
